export const environment = {
  production: true,
  version: require('../../package.json').version,
  platform: 'staging',
  appInsights: {
    instrumentationKey: 'd2fbd847-7871-4355-88be-ca89b6113e40',
    connectionString:
      'InstrumentationKey=d2fbd847-7871-4355-88be-ca89b6113e40;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/;ApplicationId=f459f422-bc58-4e2e-966e-1e8a357fa4be',
    enableApplicationInsights: false
  },
  API_URL: 'https://stagingapi.mxnodeapp.co.za/v2/'
};
